// src/js/store/index.js
import { createStore } from "redux";
import rootReducer from "../reducers/index";

const persistedState = localStorage.getItem('admin') ? JSON.parse(localStorage.getItem('admin')) : { admin: {}}

const store = createStore(rootReducer, persistedState);
store.subscribe(() => {
    localStorage.setItem('admin', JSON.stringify(store.getState()))
})
export default store;
